import React from 'react';
import classNames from 'classnames';
import Icon from '@/componentsDS/Icon/Icon';
import Button from '@/componentsDS/Button/Button';
import PropTypes from 'prop-types';
import { ButtonType, ButtonVariant } from '@/componentsDS/Button/Button.type';

export const ChipType = {
	FILTER: 'filter',
	INPUT: 'input',
};

const CheckIcon = () => (
	<Icon name="check" size="small" style="outlined" data-testid="check-icon" />
);

const RemoveIcon = () => (
	<Icon name="x-mark" size="small" style="outlined" data-testid="remove-icon" />
);

const Chips = ({
	label,
	size = 'default',
	type,
	disabled = false,
	readOnly = false,
	selected,
	onClick,
	onRemove,
	onRemoveTooltipText,
	addClass,
}) => {
	const chipClass = classNames('DS__chip', addClass, {
		'DS__chip--filter': type === ChipType.FILTER,
		'DS__chip--small': size === 'small',
		'DS__chip--selected': selected,
		'DS__chip-read-only': readOnly && type === ChipType.INPUT,
		'DS__chip--disabled': disabled,
	});

	const chipLabelClass = classNames('DS__chip__label', {
		'DS__chip-label--small': size === 'small',
	});

	const handleClick = (e) => {
		e.stopPropagation();
		if (disabled || readOnly) return;

		if (onRemove) {
			return onRemove();
		}

		if (onClick) {
			return onClick();
		}
	};

	return (
		<Button
			type={ButtonType.CHIP}
			variant={ButtonVariant.CHIP}
			onClick={handleClick}
			prefixIcon={type === ChipType.FILTER && selected ? <CheckIcon /> : null}
			suffixIcon={!disabled && !readOnly && onRemove ? <RemoveIcon /> : null}
			text={<span className={chipLabelClass}>{label}</span>}
			tooltipText={onRemoveTooltipText}
			addbtnClass={chipClass} // Apply chipClass to the button's className
		/>
	);
};

Chips.propTypes = {
	label: PropTypes.string.isRequired,
	size: PropTypes.oneOf(['default', 'small']),
	type: PropTypes.oneOf(Object.values(ChipType)).isRequired,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	selected: PropTypes.bool,
	onClick: PropTypes.func,
	onRemove: PropTypes.func,
	onRemoveTooltipText: PropTypes.string,
	addClass: PropTypes.string,
};

export default Chips;
